// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__4zg1J","modalForm":"UpgradeEpcsModal_modalForm__2Foqe","modalFooter":"UpgradeEpcsModal_modalFooter__39BwI"};